<div class="referral-dialog">
  <section class="referral-dialog__banner">
    <img src="/assets/img/banners/referral.svg" alt="referral-banner" />
    <p>
      {{ 'INVITE_GET' | translate | uppercase }} <span>{{ '15_EUR' | translate | uppercase }}</span>
    </p>
  </section>
  <section class="referral-dialog__content">
    <div class="referral-dialog__content__referral">
      <p class="body-14-bold">{{ 'SHARE_REFERRAL_CODE' | translate }}</p>

      <div class="input-container" (mouseleave)="copied = false">
        <input [value]="referralCode" disabled />

        @if (copied) {
          <img
            class="pointer"
            [src]="'/assets/img/icons/valid.svg'"
            alt="copy"
            width="14px"
            (click)="copySponsorshipCode()"
          />
        } @else {
          <button type="button" mat-flat-button color="primary" (click)="copySponsorshipCode()">
            {{ 'COPY' | translate }}
          </button>
        }
      </div>

      <div class="social-medias">
        <img
          class="pointer"
          width="42"
          height="42"
          src="/assets/img/icons/social-medias/email.svg"
          alt="email"
          (click)="openSocialNetworkLink('email')"
        />
        <img
          class="pointer"
          width="42"
          height="42"
          src="/assets/img/icons/social-medias/messenger.png"
          alt="messenger"
          (click)="openSocialNetworkLink('messenger')"
        />
        <img
          class="pointer"
          width="42"
          height="42"
          src="/assets/img/icons/social-medias/whatsapp.svg"
          alt="whatsapp"
          (click)="openSocialNetworkLink('whatsapp')"
        />
        <img
          class="pointer coin-icon"
          width="42"
          height="42"
          src="/assets/img/icons/social-medias/x.png"
          alt="x"
          (click)="openSocialNetworkLink('x')"
        />
        <img
          class="pointer"
          width="42"
          height="42"
          src="/assets/img/icons/social-medias/telegram.png"
          alt="telegram"
          (click)="openSocialNetworkLink('telegram')"
        />
      </div>
    </div>
    <div class="success-chip">
      <img width="16" height="16" src="/assets/img/icons/success.svg" alt="success" />
      <p class="body-14-med">{{ 'REFERRAL_CHIP' | translate }}</p>
    </div>
  </section>
</div>
